const tr = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title': 'Keşif Kaynak Adı',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'Kullanıcı Kimliği',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': "Service Now Url''si",
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Parola',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'Geçersiz Url',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Keşif Sıklığı',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Kullanıcılardan bilgiye dayalı kimlik doğrulama (KBA) soruları yanıtlamalarını isteyin.',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Bu popüler keşif kaynaklarından biri üzerinden uygulamalarınızı ve iş yüklerinizi keşfedin. Önceden girilmiş bilgiler, önceliklendirilmiş öneriler ve eklenme durumunun tam görünümü gibi avantajlara erişebileceksiniz.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Geri',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Keşif Kurulumu',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Çok Yakında...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'Daha Fazla Bilgi Alın',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'Bağlantı kurmak için uygulama kimlik bilgilerinizi girin. Bağlantı başarılı olduğunda verileri içe aktarabileceksiniz.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Sayfa yüklenirken bir hata meydana geldi.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Sayfayı yenilemeyi deneyin veya daha sonra tekrar kontrol edin. Sorun devam ederse yöneticinizle iletişime geçin.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Yeniden yükle',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Bağlantı Ayarları',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'CI Sınıfları***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Öznitelik Eşleme',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Bağlantı Ayrıntıları',
  'INTEGRATIONS.BUTTON.SAVE': 'Kaydet',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Seç',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'Yeni Bağlantı Oluştur',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Bu Bağlantıyı Kullan',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow Kaydedildi!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'ServiceNow keşif kaynağına bağlantınız başarıyla test edildi ve kaydedildi. Keşif kurulumunu tamamlamak için verileri içe aktarın. Bunu atlayabilirsiniz...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Varlıkları İçe Aktar',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Şimdilik Atla',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'İçe aktarım başladıktan sonra iptal edilemez',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Bana Rehberlik Et',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'Mevcut Bağlantıyı Seç',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Bağlantı Adı',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'Mevcut {total, plural, one {bir} other {#}} bağlantı yapılandırması keşfettik:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'İçe Aktarımı Başlat',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Excel dosyasından veri aktarılıyor. Lütfen bekleyin...',
  'INTEGRATIONS.TRY.AGAIN': 'Tekrar Deneyin',
  'INTEGRATIONS.CLOSE': 'Kapat',
  'INTEGRATIONS.ERROR.CONNECTION': 'Bağlantı hatası. Lütfen tekrar deneyin.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'Beklerken sayfadan çıkabilirsiniz. Süreç tamamlandığında sizi bilgilendireceğiz.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Keşif Kaynağını İçe Aktar',
  'INTEGRATIONS.FILEUPLOAD.HEADING':
    'Keşif kaynağınızı bir dosyadan içe aktarın',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'Örnek Dosya İndir',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Keşif Kaynak Adı',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Dosya adı girin',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Lütfen geçerli bir ad girin. Yalnızca harflere, rakamlara ve belirli sembollere izin verilir.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Yükleniyor...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Devam Et',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Yüklenen XLSX dosyasından ilk 10 kayıt sunulmaktadır.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'Zorunlu Başlık Eksik',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Sütun Hataları Saptandı',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Lütfen içe veri aktarımına devam etmeden önce bu sorunları düzeltin.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'İçe aktarımdan hariç tut',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Uygulama Ekleme Onayı',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'Uygulama türünü belirledik. Lütfen bunun eklemekte olduğunuz doğru uygulama türü olduğunu onaylayın.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'Eklemekte olduğunuz uygulama türü: {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'Hayır, uygulama listesinden seç',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM': 'Evet, ekliyorum',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Entegrasyonlar',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Entegrasyon Ekle',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'Şunlar için sonuç bulunamadı:',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'Entegrasyon',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'bulunamadı.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN': 'Mevcut gizli entegrasyon yok.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Uygulamalar Keşfedildi',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Sahip:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Son keşif tarihi:',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Bağlantı Kurulamadı',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'Kullanıcıların erişimi var',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Keşif Kaynağı',
  'INTEGRATIONS.BUTTON.ENABLE': 'Etkinleştir',
  'INTEGRATIONS.BUTTON.DISABLE': 'Devre Dışı Bırak',
  'INTEGRATIONS.ENABLING': 'Etkinleştiriliyor',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Keşif',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Tekrar Yükle',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Ekle',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Gizle',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Gizlemeyi kaldır',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': 'Keşif yapılandırma sekmeleri',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Kaydedilmeyen değişiklikler iptal edilsin mi?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'Kaydedilmemiş değişiklikleriniz var. Devam ederseniz değişiklikler kaybolacak.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Değişiklikleri İptal Et',
  'INTEGRATIONS.BUTTON.CANCEL': 'İptal',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Kaydetme Hatası',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL': 'Önceki sayfaya dön',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Uygulama simgesi',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Manuel Olarak Çalıştır',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE':
    'Devre Dışı Bırakma Başarısız',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE':
    'Etkinleştirme Başarısız',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'Başarıyla devre dışı bırakıldı.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'Başarıyla etkinleştirildi.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'Şu anda başka bir içe aktarım devam ediyor.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'Değerler şu anda başka bir süreç tarafından içe aktarılıyor. Lütfen daha sonra tekrar deneyin.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED':
    'İçe Aktarma Başarısız',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS':
    "ServiceNow''dan İçe Varlık Aktarma",
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'Beklerken sayfadan çıkabilirsiniz. Süreç tamamlandığında sizi bilgilendireceğiz.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Yeni öznitelik eşleme satırı ekle',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Öznitelik Ekle',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Boş)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Bu eşlemeyi sil',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'ServiceNow Alanı',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Saviynt Alanı',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'ServiceNow özniteliği ara',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'Saviynt özniteliği ara',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Özel)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Kaydetme başarısız',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Planlama Yapılandırması',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': "{timeLabel} UTC''de.",
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Tekrar Tarihi',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Tekrar Günleri',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Tekrar Aralığı',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Aralık girin',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Gün, hafta veya ay sayısı olarak tekrar aralığı',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Gün',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Hafta',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Ay',
  'INTEGRATIONS.DAYS.SUN': 'Paz',
  'INTEGRATIONS.DAYS.MON': 'Pzt',
  'INTEGRATIONS.DAYS.TUE': 'Sal',
  'INTEGRATIONS.DAYS.WED': 'Çar',
  'INTEGRATIONS.DAYS.THU': 'Per',
  'INTEGRATIONS.DAYS.FRI': 'Cum',
  'INTEGRATIONS.DAYS.SAT': 'Cmt',
  'INTEGRATIONS.BUTTON.DISABLING': 'Devre Dışı Bırakılıyor',
  'INTEGRATIONS.BUTTON.SAVED': 'Kaydedildi',
  'INTEGRATIONS.BUTTON.SAVING': 'Kaydediliyor',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE':
    'Şunları devre dışı bırakmak istediğinizden emin misiniz: ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'Keşif kaynağı devre dışı bırakıldığında içe varlık aktarımı durdurulur ve kaynağı yapılandıramazsınız.',
  'INTEGRATIONS.DISCOVERY.HERE': 'lütfen buraya',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    "Keşif kaynağınız başarıyla oluşturuldu ancak ServiceNow''a bağlantı başarısız oldu. Varlıkları içe aktarmaya başlamak için lütfen keşif kaynağı yapılandırma sayfasındaki bağlantı bilgilerini güncelleyin ",
};

export default tr;
